import type { ColumnDef } from '@tanstack/react-table';
import type { Visita } from '@condo/contracts';
import { format } from 'date-fns';
import { es } from 'date-fns/locale';
import { DataTable } from '@/components/common/data-table';
import { Badge } from '@/components/ui/badge';
import { useVisitasIngresos } from './api';

const tipoLabels: Record<Visita['tipo'], string> = {
  familiar: 'Familiar',
  delivery: 'Delivery',
  proveedor: 'Proveedor',
  servicio: 'Servicio',
};

const columns: ColumnDef<Visita, unknown>[] = [
  {
    accessorKey: 'visitorNombre',
    header: 'Visitante',
    cell: ({ row }) => (
      <span className="font-medium">{row.original.visitorNombre}</span>
    ),
  },
  { accessorKey: 'unidadNumero', header: 'Unidad' },
  {
    accessorKey: 'tipo',
    header: 'Tipo',
    cell: ({ row }) => tipoLabels[row.original.tipo],
  },
  {
    accessorKey: 'ingresoAt',
    header: 'Ingreso',
    cell: ({ row }) => (
      <span className="text-[var(--color-ink-muted)]">
        {format(new Date(row.original.ingresoAt), 'd MMM, HH:mm', {
          locale: es,
        })}
      </span>
    ),
  },
  {
    accessorKey: 'egresoAt',
    header: 'Egreso',
    cell: ({ row }) =>
      row.original.egresoAt ? (
        <span className="text-[var(--color-ink-muted)]">
          {format(new Date(row.original.egresoAt), 'd MMM, HH:mm', {
            locale: es,
          })}
        </span>
      ) : (
        <span className="text-[var(--color-ink-muted)]">—</span>
      ),
  },
  {
    id: 'auto',
    header: '',
    cell: ({ row }) =>
      row.original.autoCerrada ? (
        <Badge variant="neutral">auto-cerrada</Badge>
      ) : null,
  },
];

export function HistorialCondominioTab({ condoId }: { condoId: string }) {
  const { data, isLoading } = useVisitasIngresos(condoId, {
    estado: 'finalizada',
  });

  return (
    <DataTable
      columns={columns}
      data={data?.items ?? []}
      isLoading={isLoading}
      empty={
        <span className="text-sm text-[var(--color-ink-muted)]">
          Sin historial todavía.
        </span>
      }
    />
  );
}
